<template>
  <div class="mt-5">
  <div class="wrap mt-5">
    <div v-if="timeMsg == ''" class="d-flex flex-column align-items-center cards" style="max-width:1000px">
      <div class="row inputWrap">
        <div  class="col-12 d-flex liss">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-success">應付金額</p>
            <p class="text-left w-100 pl-5" style="font-size:20px">
              NT${{ order.real_price | thousands}} <span v-if="order.rate">(1 : {{order.rate}})</span>
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-success">付款方式</p>
            <p class="text-left w-100 pl-5">
              {{order.bank_from ? 'ATM' : (order.bank_name || '')   + '超商付款'}}
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss" v-if="order.bank_owner != 'CVS'">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-success">銀行名稱</p>
            <p class="text-left w-100 pl-5">
              {{ order.bank_name }} 
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss" v-if="order.bank_from">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-success">銀行代號</p>
            <p class="text-left w-100 pl-5">
              {{order.bank_from}}
               <button class="btn btn-success" v-clipboard:success="onCopy" v-clipboard:copy="order.bank_from">複製</button>
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss" v-if="order.bank_from">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-success">虛擬帳號</p>
            <p class="text-left w-100 pl-5">
                {{ order.bank_no.replace(/-/g,'') }}
               <button class="btn btn-success" v-clipboard:success="onCopy" v-clipboard:copy="order.bank_no.replace(/-/g,'')">複製</button>
            </p>
          </h6>
        </div>
        <div class="col-12 d-flex liss" v-if="!order.bank_from">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-success">繳費代碼</p>
            <p class="text-left w-100 pl-5 ">
              {{ order.bank_no }}
              <button class="btn btn-success" v-clipboard:success="onCopy" v-clipboard:copy="order.bank_no">複製</button>
            </p>
          </h6>
        </div>
        <div class="col-12 d-flex liss">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-success">截止日期</p>
            <p class="text-left w-100 pl-5 ">
              {{ order.expired }}
            </p>
            </h6>
        </div>
        <div class="col-12 d-flex pcBar" v-if="order.bank_name=='全家'">
          <h6 class="text-right d-flex flex-wrap-wrap  my-2 border-b">
            <p style="white-space:nowrap" class="text-success">繳費條碼</p>
            <div class="w-100 d-flex flex-column barcodeWrap justify-content-center codeWrap">
                <p class="codeInfo">全家便利商店FamiPort</p>
                <div style="" v-if="codeData">
                  <img style="height:30px" :src="'https://ecb.famiport.com.tw/familyec/code39.ashx?id=' + codeData.BARCODE_1" alt="">
                  <p style="font-size:12px" class="codeText">*{{ codeData.BARCODE_1 }}*</p>
                </div>
                <div style="" v-if="codeData">
                  <img style="height:30px" :src="'https://ecb.famiport.com.tw/familyec/code39.ashx?id=' + codeData.BARCODE_2" alt="">
                  <p style="font-size:12px" class="codeText">*{{ codeData.BARCODE_2 }}*</p>
                </div>
                <div style="" v-if="codeData">
                  <img style="height:30px" :src="'https://ecb.famiport.com.tw/familyec/code39.ashx?id=' + codeData.BARCODE_3" alt="">
                  <p style="font-size:12px" class="codeText">*{{ codeData.BARCODE_3 }}*</p>
                </div>
                <button class="btn btn-success createBtn" style="float:left" @click="createCode">{{ codeData ? '重新產生' : '產生繳費條碼' }}</button>
                <!-- <p v-if="familyTimeout > 0">條碼到期: {{ Math.trunc(familyTimeout/60) }}分{{ familyTimeout%60 }}秒</p> -->
              </div>
          </h6>
        </div>
      </div>
    </div>
    <div v-if="timeMsg != ''" class="timeMsg">
      <h4 class="tit1">{{timeMsg}}</h4>
    </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VueQrcode from 'vue-qrcode'
import VueBarcode from 'vue-barcode';

export default {
  components: {
    VueQrcode,
    'barcode': VueBarcode
  },
  data() {
    return {
      bankName:"",
      order:"",
      timeout: "",
      timeMsg: "",
      codeData:"",
      // familyTimeout:"",
      // familyTimeoutHandler:""
    };
  },
  computed: {},
  methods: {
    createCode(){
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}/ccc/query_barcode?transaction_id=${this.$route.query.transaction_id}`
        ).then(res=>{
          if(res.data.code == 0) {
            if(res.data.data?.STATUS == 'S') {
              this.codeData = res.data.data;
            }
            if(res.data.data?.STATUS == 'F') {
              this.$message.error('獲取條碼失敗。 若已繳費請勿重複繳款')
            }
          }
        })
    },
    onCopy(){
      this.$message.success('複製成功')
    },
    getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}/ccc/query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          if (res.data.code == 0) {
            this.order = res.data.data;
            if(res.data.data.bank_name=='' || res.data.data.bank_name.toLocaleLowerCase() == '711'.toLocaleLowerCase() || res.data.data.bank_name.toLocaleLowerCase() == 'OK'.toLocaleLowerCase() || res.data.data.bank_name.toLocaleLowerCase() == 'Family'.toLocaleLowerCase()) {
             if(res.data.data.bank_name=='') {
                this.bankName = '711'
             }else {
               this.bankName = res.data.data.bank_name.toLocaleLowerCase()
             }
            }else {
              this.bankName = ''
            }
          } else {
            this.timeMsg = res.data.message;
            clearInterval(this.timeout);
          }
        });
    }
  },
  created() {
    this.getOrder();
    this.timeout = setInterval(() => this.getOrder(), 60000);
  }
};
</script>
<style lang="scss">
  .imgWrap {
    display: flex;
    margin-bottom: 10px;
  }
body {
  background-color: #EBEFF0 !important;
}
.wrap {
  font-family: 新細明體 !important;
  width: 100%;
  min-height: 90vh;
  border-radius: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
}
p {
  color:black;
  font-size: 16px;
  word-break:break-all;
}
.cards {
  width: 100%;
  box-shadow: 1;
  background-color: #fff;
  display: block;
  padding: 30px 50px;
  border-radius: 10px;
  margin-bottom: 30px;
  -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
  box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
}
.liss:nth-child(even){
  // justify-content: flex-end;
}
.liss:nth-child(even){
  justify-content: flex-start  !important;
  h6 {
  justify-content: space-between  !important;
  width: 100%;
    flex-direction: row !important;
  }
}
  .h6T {
  justify-content: space-between  !important;
  width: 100%;
    // flex-direction: column;
    p {
      // text-align: left;
      margin-bottom: 0;
    }
  }
@media(max-width:768px) {
.liss:nth-child(even){
  justify-content: flex-start  !important;
  h6 {
  justify-content: space-between  !important;
  width: 100%;
    flex-direction: row !important;
  }
}
  .h6T {
  justify-content: space-between  !important;
  width: 100%;
    // flex-direction: column;
    p {
      // text-align: left;
      margin-bottom: 0;
    }
  }
  .cards {
    padding: 20px
  }
}
.tit1 {
  margin-bottom: 30px;
  border-bottom: 3px solid #007bff;
  padding-bottom: 20px;
}

h6 {
  line-height: 2;
}
.inputWrap {
  // border-top: 3px solid #CCC;
  // border-bottom: 3px solid #CCC;
}
.border-b {
  width: 100%;
  border-bottom: 1px solid #CCC;
  p{
    &:first-child {
      width: 400px;
      text-align: left;
    }
  }
}
  .btn{
    padding: 5px;
    border-radius: 5px;
    min-width: 80px;
    color:white;
    // background-color: #4669E7;
    float:right;
    margin-bottom:5px;
    &:hover{
      color:white;
    }
  }
  .lanWrap {
    display: flex;
    justify-content: flex-end;
    .lanBox {
      padding: 3px 5px;
      border: 1px solid black;
      border-radius: 3px;
      margin-left: 5px;
      margin-right: 5px;
      cursor: pointer;
      &.active {
        color:white;
        background-color: #4669E7;
        border: 1px solid gray;
      }
    }
  }
  .t1 {
    text-align: center;
  }
  .t2 {
    text-align: right;
  }
  @media(max-width:500px) {
    .t1 {
      text-align: left;
    }
    .t2 {
      text-align: center;
    }
    .tit1 {
      font-size: 24px;
    }
    .border-b {
      flex-wrap: wrap;
      p{
        &:last-child {
          padding-left: 0 !important;
        }
      }
    }
  }
  .noQrcode {
    width: 150px;
    margin-top: -20px;
  }

  .imgWrap {
    display: flex;
    img {
      width: 100px;
      height: 106px;
    }
  }

  .barcodeWrap {
    padding-left: 1.75rem;
  }
  @media(max-width:768px) {
    .barcodeWrap {
      padding-left: 0px;
    }
  }
  .codeWrap {
    align-items: flex-start;
  }
  .codeText {
    text-align: center;
    // padding-left: 10px;
  }
  .createBtn {
    margin-left: 15px;
  }
  @media(max-width:768px) {
  .codeText {
    // text-align: center;
    // padding-left: 0;
  }
    .codeWrap {
      align-items: center;
    }
    .createBtn {
      margin-left: 0px;
    }
    .codeInfo {
      text-align: center !important;
    }
  }
</style>
